/* import __COLOCATED_TEMPLATE__ from './transfer-outage-banner.hbs'; */
var _dec, _dec2, _dec3, _class, _descriptor, _descriptor2;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@glimmer/component';
import { action, computed } from '@ember/object';
import { inject as service } from '@ember/service';
import { BannerV2Format } from '@square/dashboard-protos/models/squareup/messageservice/service';
import { open } from '@square/dashboard-utilities/utils/window';
let TransferOutageBanner = (_dec = computed('currentMessage.bannerV2Format'), _dec2 = computed('currentBanner.primaryLinkText'), _dec3 = computed('currentBanner.type'), _class = class TransferOutageBanner extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "sentry", _descriptor, this);
    _initializerDefineProperty(this, "logEvents", _descriptor2, this);
  }
  get currentMessage() {
    if (this.args.messageUnits.length > 0) {
      const currentMessage = this.args.messageUnits[0];
      return currentMessage;
    } else {
      this.sentry.withScope(scope => {
        scope.setLevel('warning');
        this.sentry.captureMessage('No message units found');
      });
      throw new Error('No message units found');
    }
  }
  get currentBanner() {
    return this.currentMessage?.bannerV2Format;
  }
  get showPrimaryCTA() {
    return Boolean(this.currentBanner?.primaryLinkText);
  }
  get bannerType() {
    switch (this.currentBanner?.type) {
      case BannerV2Format.BannerV2Type.BANNER_V2_TYPE_CRITICAL:
        return 'critical';
      case BannerV2Format.BannerV2Type.BANNER_V2_TYPE_INFO:
        return 'info';
      case BannerV2Format.BannerV2Type.BANNER_V2_TYPE_WARNING:
      default:
        return 'warning';
    }
  }
  openMessageUnitPrimaryLink() {
    if (this.currentBanner?.primaryLinkWebUrl) {
      open(this.currentBanner.primaryLinkWebUrl, '_blank', 'noopener noreferrer');
    }
    if (this.currentBanner?.primaryClickLogEvent) {
      this.logEvents.track(this.currentBanner.primaryClickLogEvent, this.currentBanner.primaryClickLogEvent?.dynamicProperties);
    }
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "sentry", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "logEvents", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "currentBanner", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "currentBanner"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showPrimaryCTA", [_dec2], Object.getOwnPropertyDescriptor(_class.prototype, "showPrimaryCTA"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "bannerType", [_dec3], Object.getOwnPropertyDescriptor(_class.prototype, "bannerType"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "openMessageUnitPrimaryLink", [action], Object.getOwnPropertyDescriptor(_class.prototype, "openMessageUnitPrimaryLink"), _class.prototype), _class);
export { TransferOutageBanner as default };